<template>
  <div v-if="visible" class="modal-mask">
    <div class="modal-container">
      <div class="modal-header">
        <div class="title">自定义计时</div>
        <img class="close-icon" src="@/assets/bar/close.png" alt="" />
      </div>
      <a-divider />
      <div class="modal-content">
        <a-input-number
          class="timer-input"
          :min="0"
          placeholder="请输入计时时间，单位为分钟"
          auto-focus
          @change="onChange"
        />
      </div>

      <div style="margin: 0 40px">
        <a-divider />
      </div>
      <div class="modal-footer">
        <div class="btn confirm-btn" @click="handleConfirm">确定</div>
        <div class="btn cancel-btn" @click="hide">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomTimerModal',
  data() {
    return {
      visible: false,
      minutes: 1
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.minutes = 0
      this.visible = false
    },
    onChange(value) {
      this.minutes = value
    },
    handleConfirm() {
      this.$emit('confirm', this.minutes)
      this.hide()
    }
  }
}
</script>

<style scoped lang="scss">
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  width: 450px;
  background: #ffffff;
  border-radius: 24px;
  box-sizing: border-box;
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 22px 40px 0;
    .title {
      font-weight: bold;
      font-size: 20px;
      color: #333333;
    }
    .close-icon {
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  }

  .modal-content {
    padding: 0 40px;
    ::v-deep .timer-input {
      width: 100%;
      border: none;
      box-shadow: none;
      font-weight: 400;
      font-size: 20px;
      color: #333333;
      &:hover,
      &:focus {
        border: none;
        box-shadow: none;
      }
      .ant-input-number-handler-wrap {
        display: none;
      }
      .ant-input-number-input {
        width: 100%;
        height: 70px;
        line-height: 70px;
        text-align: center;
        background: #f6f6f6;
        border-radius: 16px;
      }
    }
  }

  .modal-footer {
    padding: 0 40px 28px;
    display: flex;
    justify-content: space-around;
    .btn {
      width: 175px;
      height: 54px;
      border-radius: 100px;
      font-weight: 400;
      font-size: 17px;
      text-align: center;
      line-height: 54px;
      cursor: pointer;
      &.confirm-btn {
        background: linear-gradient(270deg, #66adff 0%, #1976ff 100%);
        color: #ffffff;
      }
      &.cancel-btn {
        background: #f6f6f6;
        color: #666666;
      }
    }
  }
}
</style>
